import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';
import { fetchSearches } from 'v2/hooks/useFetchSearchesPaginated';
import { REVIEW_STATUS } from 'v2/utils/searchUtils';
import { searchViewPath } from 'v2/utils/searchViewUtils';

const InProgressRedirect = () => {
  const history = useHistory();

  useQuery(
    ['get_requests_under_review_and_in_progress'],
    async () => {
      const promises = [
        fetchSearches({
          size: 1,
          review_status: REVIEW_STATUS.UNDER_REVIEW,
          active: true,
          depth: 'individual',
        }),
        fetchSearches({
          size: 1,
          review_status__ne: REVIEW_STATUS.UNDER_REVIEW,
          active: true,
          depth: 'organization',
        }),
      ];

      const [inReview, inProgress] = await Promise.all(promises);

      return {
        inReviewCount: inReview.count,
        inProgressCount: inProgress.count,
      };
    },
    {
      onSuccess: (data) => {
        const page =
          !data.inProgressCount && data.inReviewCount
            ? searchViewPath.inReview
            : searchViewPath.inProgress;
        history.push(`${page}/1`);
      },
      onError: () => {
        history.push(`${searchViewPath.inProgress}/1`);
      },
    }
  );
  return null;
};

export default InProgressRedirect;
